import {
  OptionsObject,
  useSnackbar as useNotistack,
} from '@automata/rexports/notistack';

export type SnackbarOptions = OptionsObject;
export const useSnackbar = useNotistack;
